import gql from 'graphql-tag';
import localforage from 'localforage';

const GET_SELF = gql`
  {
    self {
      _id
      email
      username
      role
    }
  }
`;

const LOGIN_ADMIN = gql`
  mutation($email: String!, $password: String!) {
    auth(email: $email, password: $password)
  }
`;

export const check = () => (dispatch, _, client) => (
  client.query({ query: GET_SELF })
    .then(res => dispatch({ type: 'AUTH_LOGGED_IN', payload: res.data.self }))
    .catch(() => dispatch({ type: 'AUTH_LOGIN_FAILED' }))
);

export const login = (payload) => (dispatch, _, client) => (
  client.mutate({ mutation: LOGIN_ADMIN, variables: payload })
    .then(res => {
      const { user, token } = res.data.auth;
      localStorage.setItem('auth_token', token);
      dispatch({ type: 'AUTH_LOGGED_IN', payload: user });
    })
);

export const logout = () => (dispatch, _, client) => {
  localStorage.clear();
  return Promise.all([localforage.clear(), client.clearStore()])
    .then(() => dispatch({ type: 'AUTH_LOGGED_OUT' }));
};
